import { FC } from 'react';
import { Checkbox } from '@/components/ui';
import type { DraftSlot } from '../../../../../drop-generator.types';
import { GroupChip } from '../../../../shared/GroupChip';
import { listChoiceOf } from '../../../groups/lists-per-day/list-choice';
import type { GroupRef } from '../../hooks/use-general-times';
import type { SlotPatch } from '../../../state/slots/slot-ops';

export const DropGroupOption: FC<{
  group: GroupRef;
  slot: DraftSlot;
  defaultAmount: number;
  together: boolean;
  onToggle: () => void;
  onPatch: (patch: SlotPatch) => void;
}> = ({ group, slot, defaultAmount, together, onToggle, onPatch }) => {
  const on = slot.listGroupIds.includes(group.id);
  const own = slot.amountsByGroup?.[group.id];
  const setOwn = (raw: string) => {
    const next = { ...(slot.amountsByGroup ?? {}) };
    if (raw === '') delete next[group.id];
    else next[group.id] = Number(raw);
    onPatch({ amountsByGroup: Object.keys(next).length > 0 ? next : null });
  };
  return (
    <div className="rounded-md hover:bg-muted/30">
      <div className="flex min-h-8 items-center gap-2 px-1.5">
        <Checkbox checked={on} onCheckedChange={onToggle} aria-label={`${group.name} sends at this drop`} />
        <button type="button" onClick={onToggle} className="rounded-full" tabIndex={-1}>
          <GroupChip name={group.name} color={group.color} />
        </button>
        {on && listChoiceOf(group.listsPerDay) === 'all' && slot.listsByGroup?.[group.id] === undefined ? (
          <span
            className="text-[10px] font-semibold uppercase tracking-wider text-primary"
            title={slot.listsRankByGroup?.[group.id] ? `This drop takes ${group.name}'s #${slot.listsRankByGroup[group.id]} list of the day` : `${group.name} is set to all lists (List groups tab)`}
          >
            {slot.listsRankByGroup?.[group.id] ? `#${slot.listsRankByGroup[group.id]}` : 'all lists'}
          </span>
        ) : null}
        {on && together ? (
          <input
            type="number"
            min={1}
            max={50000}
            value={own ?? ''}
            placeholder={String(slot.amount ?? defaultAmount)}
            onChange={(e) => setOwn(e.target.value)}
            aria-label={`${group.name}'s own amount on this drop`}
            className={`ml-auto h-7 w-20 rounded-md border bg-transparent px-2 font-mono text-xs tabular-nums outline-none ${own !== undefined ? 'border-primary/60' : 'border-input text-muted-foreground'}`}
          />
        ) : null}
      </div>
    </div>
  );
};
